import { ApiService } from "@/services/api/ApiService";
import type { KnowledgeRecommendation } from "@/types/knowledge/knowledge-recommendations";

const RESOURCE = "knowledge-recommendations";

export class KnowledgeRecommendationsService {
  static async list(options?: {
    status?: string;
    agentId?: string;
  }): Promise<KnowledgeRecommendation[]> {
    const result = await ApiService.invoke<{ recommendations: KnowledgeRecommendation[] }>({
      resource: RESOURCE,
      action: "list",
      data: {
        ...(options?.status && { status: options.status }),
        ...(options?.agentId && { agentId: options.agentId }),
      },
    });
    return result?.recommendations || [];
  }

  static async accept(recommendationId: string): Promise<{ applied: boolean; refreshed: boolean }> {
    return ApiService.invoke({
      resource: RESOURCE,
      action: "accept",
      data: { recommendationId },
    });
  }

  static async dismiss(recommendationId: string): Promise<{ dismissed: boolean }> {
    return ApiService.invoke({
      resource: RESOURCE,
      action: "dismiss",
      data: { recommendationId },
    });
  }

}
